'use strict';
var PropTypes = require('prop-types');

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __rest =
  (void 0 && (void 0).__rest) ||
  function (s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
          t[p[i]] = s[p[i]];
      }
    return t;
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var components_1 = require('../../../constants/components');

var BaseButton = function BaseButton(props) {
  var _a = props.type,
    type = _a === void 0 ? components_1.BUTTON_TYPES.button : _a,
    children = props.children,
    restProps = __rest(props, ['type', 'children']);

  return (
    // eslint-disable-next-line react/button-has-type
    react_1.default.createElement(
      'button',
      __assign(
        {
          type: type,
        },
        restProps
      ),
      children
    )
  );
};

BaseButton.propTypes = {
  children: PropTypes.node,
  /**
   * Устанавливает тип кнопки
   *  @default "button"
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

BaseButton.displayName = 'BaseButton';
exports.default = BaseButton;
